import { useQuery } from "@apollo/client";
import { MY_HR_GET_DEPENDENTS } from "my-hr/graphql";
import { useOcCurrentUserState, useOcPolling } from "oc/hooks";

export const useOcDependentsData = () => {
  let { contractCode } = useOcCurrentUserState();
  const { data, loading, error } = useQuery(MY_HR_GET_DEPENDENTS, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
    variables: {
      contractCode,
    },
  });
  const result = data?.dependents || [];
  return {
    data: result,
    loading,
    error,
  };
};

export default useOcDependentsData;
